import { ReactNode } from 'react'

import { useActionless, useAppSelector } from 'redux/hooks'
import { SET_ACTIVE_STATE } from 'redux/active/actions/types'

import GlobalOverlayStack from 'components/elements/Overlay/GlobalOverlayStack'
import { InDeckCardGrid } from 'components/cardSearchPanel/cardLayouts/cardResultsGrid'

import styles from './cardComparisonOverlay.module.scss'

const CardComparisonOverlay = () => {
  const multiSelectedIds = useAppSelector(state => state.active.multiSelectedIds)
  const comparingCards = useAppSelector(state => state.active.compareCardsOverlay)
  const [setActiveState] = useActionless(SET_ACTIVE_STATE)

  const handleClose = () => {
    setActiveState({ compareCardsOverlay: false })
  }

  return (
    <GlobalOverlayStack className={styles.container} open={!!comparingCards} onClose={handleClose}>
      <h3>Selected Cards</h3>
      <InDeckCardGrid cardIds={Object.keys(multiSelectedIds)} />
    </GlobalOverlayStack>
  )
}

export default CardComparisonOverlay

type StandaloneCardGridOverlayProps = {
  open: boolean
  onClose: () => void
  cardIds: string[]
  header?: ReactNode
}

export const StandaloneCardGridOverlay = ({ open, onClose, cardIds, header }: StandaloneCardGridOverlayProps) => {
  return (
    <GlobalOverlayStack className={styles.container} open={open} onClose={onClose}>
      <h3>{header || 'Related cards'}</h3>
      <InDeckCardGrid cardIds={cardIds} />
    </GlobalOverlayStack>
  )
}
